<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <BannerComponent @scroll-to-section="scrollToSection()"/>
    <div ref="sectionToScroll">
      <SectionComponent 
        v-for="(section, index) in sectionsData" 
        :key="index" 
        :image-url="require(`@/assets/home/${section.imageName}`)" 
        :heading="section.heading" 
        :subheading="section.subheading"
        :is-flip="section.flip"
        :is-opaque="section.opaque"
        :content="section.content"
        :isBlack="section.isBlack"
        data-aos="fade-up"
      />
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/home/BannerComponent.vue';
import SectionComponent from '@/components/home/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
       sectionsData: [
        {
          imageName: 'G14C-Website-Image-cognitive-and-generative-ai.png',
          heading: 'Generative and Cognitive AI',
          subheading: 'Unlocking the Future Together',
          flip: false,
          opaque: false,
          isBlack: true,
          content: `G14C is currently implementing AI/ML solutions for the Centers of Medicare & Medicaid Services (CMS), Defense Human Resources Activity (DHRA), Department of Energy (DOE), Department of the Treasury, Food and Drug Administration (FDA), and the Health Resources Services Administration (HRSA). Our experience includes the implementation of AI/ML for active threat intelligence for the Centers of Medicare & Medicaid Services (CMS), Information Security and Privacy Group (ISPG) on our Cyber Risk Management (CRM) task order involving the piloting, designing, developing, and implementation of CMS’s Security Data Lake (SDL), and how we are using AI/ML to perform continuous threat intelligence. For more information regarding our expertise implementing AI/ML solutions visit our solutions page (have the link to solutions) and review ComplySync ATO, and SDL.`
        },
        {
          imageName: 'G14C-Website-Image-Cybersecurity.png',
          heading: 'Cybersecurity',
          subheading: 'Protecting High Value Assets',
          flip: false,
          opaque: false,
          isBlack: false,
          content: `G14C cybersecurity subject matter experts provide Information System Security Officer as a Service (ISSOaaS) and capabilities for designing and developing cybersecurity solutions, and processes to protect our customers’ infrastructure, networks, systems, applications, and data. Our cyber experts develop and implement cyber solutions that identify, minimize, isolate and mitigate cyber threats. Our cyber experts design, test, and implement response and disaster recovery plans based on our customer’s cyber risk policies and standards. Our cyber professionals have expertise implementing and utilizing Security Information and Event Management (SIEM) tools and technologies performing tasks that involve Continuous Diagnostics and Mitigation (CDM), incident response, threat hunting, disaster recovery, and business continuity.`
        },
         {
          imageName: 'G14C-Website-Image-digital-Services.png',
          heading: 'Digital Services',
          subheading: 'Implementing Digital Initiatives',
          flip: false,
          opaque: false,
          isBlack: false,
          content: `G14C Digital Services provide customers with a broad range of capabilities and solutions delivered electronically utilizing digital technology including Software as a Service (SaaS), UI/IX Design, Data Fabric Architecture, Analytics, and Process Automation. G14C’s Digital Services have evolved and adapted over decades providing customers in the Federal, State, and Local government sectors, as well as commercial clients, and non-profits with deep and broad capabilities for transforming your business. Utilize our proven approach to transform your business by engaging G14C for integrating digital technologies that fundamentally change and improve how the business operates by delivering value to users, customers, and partners.`
        },
        {
          imageName: 'Health-IT-Services.jpg',
          heading: 'Health IT Services',
          subheading: 'We Care and We Act',
          flip: false,
          opaque: true,
          isBlack: true,
          content: `Healthcare transcends merely diagnosis and treatment; it is a well-balanced blend of individuals, processes, and leading-edge technology. This encompasses not just the physicians and their patients, but extends to administrators, intricate networks, and the ever-advancing information technology (IT) systems that underpin this complex environment. At G14C, we possess a deep understanding of the vital role Healthcare Organizations play in elevating the quality of care, reducing or altogether eliminating errors, and promoting value-based healthcare. We are committed to guiding your organization through a transformative journey that revolutionizes communications, operations, data defense, security, and analysis within the vast healthcare landscape. Together, our unwavering focus is paramount in delivering the highest standard of Healthcare IT Services for the Healthcare industry.`
        },
        {
          imageName: 'G14C-Website-Image-national-security.png',
          heading: 'National Security Services',
          subheading: 'Protecting Our Freedom',
          flip: true,
          opaque: true,
          isBlack: true,
          content: `G14C provides a full range of services and solutions necessary for National Security and the Department of Defense (DoD) to satisfy its support of the nation’s military enterprise infrastructure goals with IT services throughout CONUS and OCOUNS locations. Our services include solutions necessary for DoD’s transition from service-centric information environments to the enterprise and cloud environments. The IT services and solutions we provide include application modernization, business intelligences, cloud computing, cybersecurity, DevSecOps, and digital services in support of our Intelligence Analysts, and Warfighters protecting our freedom and national security.`
        }
      ]
    };
  },
  setup() {
    const sectionToScroll: Ref<HTMLElement | null> = ref(null);

    const scrollToSection = () => {
      if (sectionToScroll.value) {
        const yOffset = -64; 
        const element: HTMLElement | null = sectionToScroll.value; 
        let y;
        element ? y = element.getBoundingClientRect().top + window.pageYOffset + yOffset : '';
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    };

    return {
      sectionToScroll,
      scrollToSection
    };
  },
});
</script>
